import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import {API_BASE_URL} from '../config';

export default function RaceNavigation({meeting, race, date, search}: {meeting:string;race:number;date:string;search:string}) {
  const [numbers,setNumbers]=useState<number[]>([]);
  useEffect(()=>{
    let active=true; setNumbers([]);
    const ac=new AbortController();
    if(date) axios.get(`${API_BASE_URL}/api/meetings/date/${encodeURIComponent(date)}`,{signal:ac.signal}).then(r=>{
      const card=r.data.find((m:any)=>String(m.meeting_name).trim().toUpperCase()===meeting.trim().toUpperCase());
      if(active)setNumbers(Array.from(new Set<number>((card?.races || []).map((r:any)=>Number(r.race_number)))).filter(n=>n>0).sort((a,b)=>a-b));
    }).catch(()=>{});
    return()=>{active=false;ac.abort();};
  },[meeting,date]);
  const index=numbers.indexOf(race);
  const url=(n:number)=>`/race/${encodeURIComponent(meeting)}/${n}${search}`;
  return <nav className="race-number-nav" aria-label="Races at this meeting">
    <strong>{meeting}</strong>
    {index>0?<Link to={url(numbers[index-1])} aria-label="Previous race">‹</Link>:<span aria-disabled="true">‹</span>}
    {(numbers.length?numbers:[race]).map(n=><Link key={n} to={url(n)} aria-current={n===race?'page':undefined}>R{n}</Link>)}
    {index>=0&&index<numbers.length-1?<Link to={url(numbers[index+1])} aria-label="Next race">›</Link>:<span aria-disabled="true">›</span>}
  </nav>;
}
